import React from 'react';
import datetime from '../../Datetime';
import { Label } from '../teaserPrimitiveStyles';
import { cx } from '@linaria/core';
import { Typo } from '../../Typo';
import { Root } from '../AvailableSince/styles';
function AvailableTo({ date }) {
    /** Variables */
    const remainingTime = datetime.getFormatRemainingTime(0, date);
    /** JSX */
    return remainingTime ? (React.createElement("span", { className: cx(Label.base, Root.base, Typo.base, Typo.info03) }, remainingTime)) : null;
}
export default AvailableTo;
